export default "__VITE_ASSET__CHL_TR5j__"